<section class="about section-padding" id="about">
  <div class="container text-center">

    <div class="video-block">
      <div class="video-wrapper">

        <div *ngIf="!videoStarted" id="videoWrapper">
          <img
            src="/assets/images/video-poster.webp"
            alt="Casa Alta Vídeo"
            class="video-poster"
          />

          <button class="play-btn" (click)="startVideo()">
            <svg
              class="play-btn-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path fill="#fff" d="M8 5v14l11-7z" />
            </svg>
          </button>
        </div>

        <iframe
          *ngIf="videoStarted"
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/wXT4EC6WU98?autoplay=1"
          title="Casa Alta Vídeo"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>

      </div>
    </div>

    <div class="about-content">
      <h2 class="title">Um cenário vivo de estilo</h2>

      <p class="description">
        A Casa Alta nasce do universo <strong>EDWARDIAN®</strong>, marca criada por Edward Guilherme para transformar estilo, sensibilidade e curadoria em experiências reais.
      </p>

      <p class="description">
        São 350m² de área interna e externa, com ambientes integrados, cozinhas equipadas e uma atmosfera artística pensada em todos os mínimos detalhes. A estrutura já inclui som ambiente, vídeo e iluminação automatizados, além de mobiliário, louças, taças e utensílios de alto padrão – tudo pronto para receber até 80 convidados em eventos exclusivos, pessoais ou corporativos.
      </p>

      <p class="description">
        No vídeo, o próprio Edward conta como transformou essa casa nas alturas em um lugar para encontros, risadas e comemorações especiais. Aqui, você traz o motivo da celebração e seus desejos; nós cuidamos da intenção, da competência e da entrega para que este dia seja, de fato, extraordinário – <strong>a sua casa por um dia</strong>.
      </p>

      <div class="chips">
        <span class="chip">Exclusividade</span>
        <span class="chip">Curadoria autoral</span>
        <span class="chip">Estrutura completa</span>
      </div>
    </div>

  </div>
</section>
